import { footerImg } from "assets";
import styled from "styled-components";

export const FooterWrapper = styled.div`
  overflow: hidden;
  border-top: 1px solid #032b88;

  .container {
    margin-top: 3rem;
  }

  img {
    @media (max-width: 991.98px) {
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .btn-div {
    margin-top: 5rem;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 1399.98px) {
      margin-top: 3rem;
    }

    @media (max-width: 990px) {
      margin-top: 2rem;
    }
  }
`;

export const LeftDivText = styled.p`
  color: #032b88;
  font-family: "Catamaran", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-transform: capitalize;
  white-space: pre-line;

  &.margin-top {
    margin-top: 1rem;
  }

  @media (max-width: 991.98px) {
    text-align: center;
    margin-top: 1rem;
  }
`;

export const LinksWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;

  @media (max-width: 991.98px) {
    margin-top: 2rem;
  }
`;

export const LinksDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
`;

export const FooterLinks = styled.p`
  font-family: "Catamaran", sans-serif !important;
  color: #032b88;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  text-transform: capitalize;
  cursor: pointer;
  margin: 0;

  &.first-link {
    margin-top: 20px;
  }

  &::before {
    content: "•";
    margin-right: 15px;
  }
`;

export const FooterLinksHeader = styled.h2`
  font-family: "Catamaran", sans-serif !important;
  color: #032b88;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-transform: capitalize;

  &.last-text {
    text-align: center;

    @media (max-width: 991.98px) {
      margin-top: 2rem;
    }
  }
`;

export const SocialIconsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
  gap: 1rem;
`;

export const SocialIconHolder = styled.div`
  width: 46.262px;
  height: 46.262px;
  border-radius: 1000px;
  border: 2px solid #032b88;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
  cursor: pointer;
  transition: 0.3s ease-in-out all;

  &:hover {
    scale: 1.1;
    transition: 0.3s ease-in-out all;
  }

  .icon {
    color: #032b88;
    font-size: 24px;
  }
`;
export const BottomLinksWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4rem;
  margin-top: 2rem;
  margin-left: 8rem;

  @media (max-width: 575.98px) {
    gap: 2rem;
  }
  @media (max-width: 991.98px) {
    margin-left: 0;
  }
`;

export const BottomLinks = styled.p`
  font-family: "Catamaran", sans-serif;
  cursor: pointer;
  color: #032b88;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px; /* 214.286% */
  text-decoration-line: underline;
  text-transform: capitalize;
`;

export const FooterImgWrapper = styled.div``;

export const PresaleBtn = styled.button`
  --border: 5px;
  --slant: 0.7em;
  --color: #032b88;
  font-family: "Catamaran";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0.4em 1em;
  border: none;

  margin-top: 5rem;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(90.41deg, #032b88 0.34%, #032b88 99.15%);
  background-repeat: no-repeat;
  box-shadow: 0 0 0 200px inset var(--s, #0000),
    0 0 0 var(--border) inset var(--color);
  clip-path: polygon(
    0 0,
    calc(100% - var(--slant)) 0,
    100% var(--slant),
    100% 100%,
    var(--slant) 100%,
    0 calc(100% - var(--slant))
  );
  transition: color var(--t, 0.3s), background-size 0.3s;
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 150px;

  &:focus-visible {
    outline-offset: calc(-1 * var(--border));
    outline: var(--border) solid #000c;
    clip-path: none;
    background-size: 0 0;
  }
`;
